import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'bbsf-utilities';

@Component({
  selector: 'lib-empty-data',
  templateUrl: './empty-data.component.html'
})
export class EmptyDataComponent implements OnInit {

  constructor(private utilityService:UtilityService) { }

  @Input() Message: string;
  @Input() ShowImage: boolean;
  @Input() ImgURL: string;

  ngOnInit(): void {
    if (!this.ImgURL)
      this.ImgURL = "../../assets/images/noimage.png";
    if (!this.Message)
      this.Message = this.getResourceValue("NA");
  }
  getResourceValue(Key) {
    return this.utilityService.getResourceValue(Key);
  }

}
